import { CheckCircleIcon } from "@phosphor-icons/react/dist/csr/CheckCircle";
import { CircleIcon } from "@phosphor-icons/react/dist/csr/Circle";
import { XCircleIcon } from "@phosphor-icons/react/dist/csr/XCircle";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";
import { DELIVERY_PALETTE } from "@/core/colors";
import {
  isPayrollStatementDeliveryFailed,
  isPayrollStatementDeliverySuccessful,
  isTextOnlyDelivery,
} from "./delivery-status-rules";
import type { PayrollStatementNotificationDelivery } from "./types";
import { getDeliveryStatusLabel } from "./utils";

export const DeliveryStatus = ({
  delivery,
}: {
  delivery: PayrollStatementNotificationDelivery | null;
}) => {
  const status = delivery?.status ?? null;
  const isFailed = isPayrollStatementDeliveryFailed(status);
  // A text-only send skips its email on purpose; the PayPack still went out.
  const textOnly = isTextOnlyDelivery(delivery);
  const isSuccessful = textOnly || isPayrollStatementDeliverySuccessful(status);
  const Icon = isFailed
    ? XCircleIcon
    : isSuccessful
      ? CheckCircleIcon
      : CircleIcon;

  return (
    <Stack direction="row" align="center" gap={1}>
      {status ? (
        <Icon
          className={cn("h-4 w-4", {
            [DELIVERY_PALETTE.failed.foreground]: isFailed,
            [DELIVERY_PALETTE.sent.foreground]: isSuccessful,
            [DELIVERY_PALETTE.pending.foreground]: !isFailed && !isSuccessful,
          })}
        />
      ) : (
        <span className="h-2 w-2 rounded-full bg-neutral" />
      )}
      <Text
        variant="caption"
        tone={isFailed ? "destructive" : isSuccessful ? undefined : "muted"}
      >
        {textOnly ? "Sent" : getDeliveryStatusLabel(status)}
      </Text>
    </Stack>
  );
};
